import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  height: theme.typography.pxToRem(708),
  position: 'relative',
  '& .HSBGContainer': {
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 0,
  },
  '& .HSBGGradient': {
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.00) 12.86%), linear-gradient(180deg, rgba(0, 0, 0, 0.00) 44.12%, #000 100%), radial-gradient(50% 50% at 50% 49.89%, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.45) 100%)',
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 1,
  },

  '& .HSContentContainer': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
    alignItems: 'center',
    textAlign: 'center',
    margin: 'auto',
    maxWidth: theme.typography.pxToRem(900),
    height: '100%',
    paddingBottom: theme.spacing(10),
    zIndex: 5,
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      paddingRight: theme.spacing(8),
      paddingLeft: theme.spacing(8),
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(5),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
  },
  '& .HSBGPattern': {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: theme.typography.pxToRem(205),
    zIndex: 2,
    // Smooth fade at the top, normal at the bottom
    maskImage: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.common.black, 0.1)} 10%,
           ${alpha(theme.palette.common.black, 0.7)} 70%,
         ${theme.palette.common.black} 100%
      )`,
  },
  '& .HSTitle':{
        wordBreak: 'break-word',

  },
}));

export default StyledBox;
